import React from "react";
import { Chip } from "@mui/material";
import { CARE_GAP_STATUS_COLORS, WORKFLOW_STATUS_COLORS } from "../../common/constants";

export const CareGapStatusBadge = ({ statusKey, statusName, size = "small" }) => {
  const color = CARE_GAP_STATUS_COLORS[statusKey]?.chip || "default";
  return (
    <Chip
      size={size}
      label={(statusName || statusKey || "—").toString().toUpperCase()}
      color={color}
      sx={{ fontWeight: 700, letterSpacing: 0.3 }}
    />
  );
};

export const WorkflowStatusBadge = ({ workflowKey, workflowName, size = "small" }) => {
  const color = WORKFLOW_STATUS_COLORS[workflowKey] || "#9e9e9e";
  return (
    <Chip
      size={size}
      label={workflowName || workflowKey || "—"}
      sx={{
        bgcolor: color,
        color: "#fff",
        fontWeight: 600,
        "& .MuiChip-label": { px: 1 },
      }}
    />
  );
};

export const HistoricallyNonCompliantBadge = ({ size = "small" }) => (
  <Chip
    size={size}
    label="⚠ Historically non-compliant"
    sx={{
      bgcolor: "#fff3e0",
      color: "#bf360c",
      border: "1px solid #ffab91",
      fontWeight: 600,
    }}
  />
);

export const ContractualBadge = ({ qmCode, size = "small" }) => {
  if (!qmCode) return null;
  return (
    <Chip
      size={size}
      label={`${qmCode} · Contractual`}
      sx={{
        bgcolor: "#e3f2fd",
        color: "#0d47a1",
        border: "1px solid #90caf9",
        fontWeight: 600,
      }}
    />
  );
};
